module.exports = __webpack_public_path__ + "static/img/iconmenu10_white.523d18e7.svg";